const CARD_WxH_RATIO = 244 / 408
export const cardHeightFromWidth = (width: number): number => width / CARD_WxH_RATIO

// NB: heights are derived from these via `cardHeightFromWidth`.
export const CARD_WIDTH_PX = {
  portfolio: 56,
  hand: 64,
  center: 64, // the deck and last-played pile
} as const

// Cash-pile cards render at this fraction of the portfolio card beside them.
export const CASH_PILE_WIDTH_SCALE = 0.6

// Stacks of cards (neighborhoods, cash piles) fan each successive card
// down-and-right by these fractions of the card's own width/height.
const STACK_X_OFFSET_PCT = 0.1
const STACK_Y_OFFSET_PCT = 0.09

// Space around stacks, relative to the width of the cards.
const STACK_MARGIN_PCT = 0.05

interface IStackedCardGeometry {
  width: number
  height: number
  left: number
  top: number
}

/** Returns CSS properties for a single card _relative_ to its `cardStackWrapperGeometry` container. */
export const stackedCardGeometry = (
  cardWidthPx: number,
  index: number
): IStackedCardGeometry => {
  const cardHeightPx = cardHeightFromWidth(cardWidthPx)
  return {
    width: cardWidthPx,
    height: cardHeightPx,
    left: STACK_X_OFFSET_PCT * index * cardWidthPx,
    top: STACK_Y_OFFSET_PCT * index * cardHeightPx,
  }
}

interface ICardStackWrapperGeometry {
  width: number
  height: number
  margin: number
}

/** Returns CSS properties for the container of a down-right-offsetting stack of cards on the table. */
export const cardStackWrapperGeometry = (
  cardWidthPx: number,
  count: number
): ICardStackWrapperGeometry => {
  const cardHeightPx = cardHeightFromWidth(cardWidthPx)
  return {
    width: cardWidthPx + (count - 1) * STACK_X_OFFSET_PCT * cardWidthPx,
    height: cardHeightPx + (count - 1) * STACK_Y_OFFSET_PCT * cardHeightPx,
    margin: cardWidthPx * STACK_MARGIN_PCT,
  }
}
